import _ from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'src/components/Antd';
import LabelInput from 'src/components/TopLabelInput';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { getEditingValue, setEdittingMap } from '../../store';
import { EType } from '../../type';
import BtnInput from '../BtnInput';
import css from './css.less';
const Edit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onSubmit: submit,
    uuid,
    fakeFunction,
    isFake,
    hidNotes,
    hidButton,
    onChange,
  } = props;
  const _d = useDispatch();
  const { value, notes, type = EType.Add } = useSelector(getEditingValue(uuid));

  const [valueError, setValueError] = React.useState(false);

  const [notesError, setNotesError] = React.useState(false);

  const valueOnchange = (text) => {
    _d(
      setEdittingMap({
        inventoryUuid: uuid,
        obj: {
          value: text,
        },
      }),
    );
    if (onChange)
      onChange(
        type,
        {
          value: text,
        },
        notes,
      );
    if (valueError) {
      setValueError(false);
    }
  };
  const notesOnchange = (text) => {
    _d(
      setEdittingMap({
        inventoryUuid: uuid,
        obj: {
          notes: text,
        },
      }),
    );
    if (valueError) {
      setNotesError(false);
    }
  };
  const onSubmit = () => {
    if (!_.isNumber(value)) {
      setValueError(true);
      return;
    }
    if (submit) submit(type, value, notes);
    _d(
      setEdittingMap({
        inventoryUuid: uuid,
        obj: {
          notes: '',
          value: '',
          type: EType.Add,
        },
      }),
    );
  };
  const isDisabled = React.useMemo(() => {
    if (_.isNumber(value)) {
      if (type === EType.Add) {
        if (value == 0) {
          return true;
        }
        return false;
      }

      if (type === EType.Set) {
        return false;
      }
    }
    return true;
  }, [value, type]);
  const checkIsFake = (cb) => {
    if (isFake) {
      return;
    } else {
      if (cb) cb();
    }
  };
  const btns = React.useMemo(() => {
    return [
      {
        onClick: () => {
          checkIsFake(() => {
            _d(
              setEdittingMap({
                obj: {
                  type: EType.Add,
                },

                inventoryUuid: uuid,
              }),
            );
          });
        },
        value: EType.Add,
        text: getI18n('general.linkModule.Modal.add'),
      },
      {
        onClick: () => {
          checkIsFake(() => {
            _d(
              setEdittingMap({
                obj: {
                  type: EType.Set,
                },

                inventoryUuid: uuid,
              }),
            );
          });
        },
        value: EType.Set,
        text: getI18n('general.set.set'),
      },
    ];
  }, [type]);
  const openModal = (e) => {
    e.nativeEvent.stopImmediatePropagation();

    if (isFake) {
      if (fakeFunction) fakeFunction();
    }
  };
  return (
    <div className={css.container} onClick={openModal}>
      <BtnInput
        btnValue={type}
        inputValue={value}
        inputValueError={valueError}
        inputOnChange={valueOnchange}
        btns={btns}
      />

      {!hidNotes && (
        <div className={css.notesInput}>
          <LabelInput
            value={notes}
            error={notesError}
            onChange={notesOnchange}
            label={getI18n('general.notes')}
            size='small'
            className={css.firstInput}
          />
        </div>
      )}
      {!hidButton && (
        <Button
          onClick={onSubmit}
          size='small'
          type='primary'
          disabled={isDisabled}
          className={css.saveBtn}>
          {getI18n('general.save')}
        </Button>
      )}
    </div>
  );
};
export default Edit;
